import React, { useState, useEffect, useRef } from "react";
import "./Home.css";

import Header from "../Components/Header";
import Footer from "../Components/Footer";
import BodyHeader from "../Cart/BodyHeader";
import FAQ from "../Others/FAQ";

import { UpOutlined } from "@ant-design/icons";

export default function FUQ() {
  const [showHeader, setShowHeader] = useState(false);
  const [showGoTopButton, setShowGoTopButton] = useState(false);

  useEffect(() => {
    let prevScrollPos = window.pageYOffset;
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const isScrolledDown = prevScrollPos < currentScrollPos;
      const isScrollOverThreshold = currentScrollPos > window.innerHeight;

      setShowHeader(!(isScrolledDown && isScrollOverThreshold));
      setShowGoTopButton(currentScrollPos > 500); // Adjust the threshold as needed
      prevScrollPos = currentScrollPos;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const topRef = useRef(null);

  const scrollToTop = () => {
    topRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  };
  return (
    <div className="Home-Body">
      <div className="Home-Heder" ref={topRef} id="top">
        <div className={`Home-Heder-Box ${showHeader ? "" : "visible"}`}>
          <Header />
        </div>
      </div>
      <div className="Header">
        <Header />
      </div>

      <BodyHeader title="FAQ" text="FAQ" />
      <FAQ />
      <Footer />

      <button
        className={`Home-goTop-Button ${showGoTopButton ? "show" : ""}`}
        onClick={scrollToTop}
      >
        <UpOutlined />
      </button>
    </div>
  );
}
